import * as React from "react";
import { forwardRef } from "react";
const SvgWoundDistributionOne = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 5c-3.2 5.8-8 9.2-8 13.5a8 8 0 1 0 16 0C24 14.2 19.2 10.8 16 5Z" }));
const ForwardRef = forwardRef(SvgWoundDistributionOne);
export default ForwardRef;
